import img2 from "../assets/Images/6.png";
import img3 from "../assets/Images/7.png";
import img4 from "../assets/Images/8.png";
import img5 from "../assets/Images/9.png";

export const FMGEPageExplore = [
    {
        tag: 'FMGE 2025 Registration and Application',
        courses: [
            {
                heading: "FMGE 2025 Registration",
                description: "FMGE 2025 Registration is the first step to appear for the June session. Eligible candidates must register on the official NBE website. The application fee is ₹6,195, and the last date to apply will be announced by NBE.",
                // level: 'Beginner to Advance',
                // lessionNumber: 1,
                imageUrl: img2
            },
            {
                heading: "Documents Required for FMGE",
                description: "Candidates must provide proof of their medical qualification as per FMGE eligibility criteria. This section covers the mandatory documents required for successful registration and application submission.",
                // level: 'Beginner to Advance',
                // lessionNumber: 1,
                imageUrl: img3
            },
            {
                heading: "FMGE 2025 Important Dates",
                description: `• Application form starts: 28th April 2025
              • Deadline for online application: 17th May 2025
              • Date of examination: 26th July 2025
              • Declaration of result: By 26th August 2025`,
                imageUrl: img4
              }
              
        ]
    },
    {
        tag: 'FMGE Exemptions',
        courses: [
            {
                heading: "FMGE Exemption Countries",
                description: "Candidates who obtained their medical degree from the USA, UK, Canada, Australia, or New Zealand are exempt from taking the FMGE, provided they meet specific eligibility criteria to practice in these countries.",
                // level: 'Beginner to Advance',
                // lessionNumber: 1,
                imageUrl: img5
            },
            {
                heading: "Documents Required for FMGE",
                description: "Candidates must provide proof of their medical qualification as per FMGE eligibility criteria. This section covers the mandatory documents required for successful registration and application submission.",
                // level: 'Beginner to Advance',
                // lessionNumber: 1,
                imageUrl: img3
            },
        ]
    },
]
